import { DefaultApi } from './api';
import { CitiesResponse } from './types';

export const getCitiesByStateId = (stateUf: number | string) =>
  DefaultApi.request<CitiesResponse>(`/federations/cities/${stateUf}`, {
    method: 'GET',
  });
